<template>
  <div class="layout-editor-page" v-show="isVisible">
    <div class="layout-editor-page__header">
      <!-- TODO: SLOT -> TITLE -->
      <slot name="title">
        <h1 class="page-title">{{title}}</h1>
      </slot>
      <form-controls
        :isBack="isBack"
        :isCancel="isCancel"
        @command="command"
      >
        <!-- TODO: SLOT -> CONTROLS -->
        <slot name="top-controls"></slot>
      </form-controls>
    </div>
    <!-- TODO: HEADER TOOLS -> TITLE -->
    <slot name="top-tools"/>
    <div class="layout-editor-page__body white-background">
      <template v-if="error">
        <slot name="layout-error">
          <layout-error-content :error="error" />
        </slot>
      </template>
      <template v-else-if="isTabsPage" >
        <div class="layout-editor-page__tabs-mode" v-loading="isLoading">
          <!-- TODO: SLOT -> DEFAULT -->
          <slot></slot>
        </div>
      </template>
      <template v-else-if="isScrollPage">
        <slot name="tools" />
        <scroll-content :isLoading="isLoading" ref="scroll-content">
          <!-- TODO: SLOT -> DEFAULT -->
          <slot></slot>
          <template v-slot:footer>
            <!-- TODO: SLOT -> FOOTER -->
            <slot name="footer"></slot>
          </template>
        </scroll-content>
      </template>
      <template v-else>
        <!-- TODO: SLOT -> DEFAULT -->
        <slot></slot>
      </template>
    </div>
  </div>
</template>

<script>
import { APP_EVENTS } from '@/utils/events'

export default {
  name: 'LayoutEditorPage',
  components: {
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'scroll-content': () => import(/* webpackChunkName: 'Layouts' */ './ScrollContent.vue'),
    'layout-error-content': () => import(/* webpackChunkName: 'Layouts' */ './LayoutError.vue')
  },
  props: {
    isScrollPage: { type: Boolean, default: true },
    isTabsPage: { type: Boolean, default: false },
    title: { type: String },
    isVisible: { type: Boolean },
    isLoading: { type: Boolean, default: false },
    isBack: { type: Boolean, default: false },
    isCancel: { type: Boolean, default: false },
    error: {
      default: null
    }
  },
  watch: {
    isVisible (value) {
      if (value) {
        this.$bus.$emit(APP_EVENTS.SCROLL_LAYOUT_EDITOR)
      }
    }
  },
  methods: {
    command (command) {
      this.$emit('command', command)
    }
  }
}
</script>

<style lang="stylus">
  .layout-editor-page{
    display flex
    flex-direction column
    height 100%
  }
  .layout-editor-page__header{
    display flex
    align-items center
    justify-content space-between
    .default-form-controls{
      padding .5rem 0
    }
  }
  .layout-editor-page__body{
    height 100%
    min-height 500px
    display flex
    flex-direction column
    overflow hidden
  }
  .layout-editor-page__tabs-mode{
    height 100%
    .el-tabs{
      display flex
      flex-direction column
      height 100%
    }
    .el-tabs__content{
      height 100%
    }
    .el-tab-pane{
      height 100%
    }
  }
  @media only screen and (max-width: 576px) {
    .layout-editor-page{
      .default-form-controls .control > button{
        margin 0
      }
    }
    .layout-editor-page__header{
      flex-direction column
      .default-form-controls{
        width 100%
        .control{
          width 100%
        }
      }
    }
  }
</style>
